<template>
  <div class="headermodule-2" ref="headermodule">
    <div class="container clearfix">
      <div class="logo fl" @click="backindex" v-if="appdata.appLogo !== ''">
        <img :src="appdata.appLogo" alt="">
      </div>
      <div class="btn fr" v-show="!isLogin">
        <a @click="gotolink('login')">登录</a>
        <span>/</span>
        <a @click="gotolink('register')">注册</a>
      </div>
      <ul class="userbox fr" v-show="isLogin">
        <li class="nLi" @mouseover="userFlag = true" @mouseleave="userFlag = false">
          <h3 class="top"><img :src="user.userimage" alt=""><span>{{ user.username }}</span></h3>
          <el-popover
            placement="bottom-end"
            v-model="userFlag">
            <ul class="ul1">
              <li><a @click="gopersonalcenter"><i class="el-icon-user"></i>个人中心</a></li>
              <li @click="quitlogin"><a><i class="el-icon-switch-button"></i>退出</a></li>
            </ul>
          </el-popover>
        </li>
      </ul>
      <ul class="search_btn fr pcshow">
        <li class="nLi">
          <h3><a @click="gosearch" class="btn">搜索</a></h3>
        </li>
      </ul>
      <el-menu
        class="el-menu-demo fl"
        mode="horizontal"
        background-color="transparent"
        active-text-color="#ffd04b"
        text-color="#fff"
        @select="handleSelect"
      >
        <menuTree :menu-data="navdata"/>
      </el-menu>
    </div>
  </div>
</template>

<script>
import menuTree from '@/components/header/menu'
export default {
  name: 'headerModule2',
  props: {
    appdata: {
      type: Object
    },
    navdata: {
      default: []
    },
    layerseries: {
      default: 0
    }
  },
  components: {
    menuTree
  },
  data () {
    return {
      userFlag: false,
      isLogin: false,
      user: {
        userimage: this.$cookie.get('wlyuserimg'),
        mobilephone: this.$cookie.get('wlymobilephone'),
        username: ''
      },
      isCollapse: true,
      newNavdata: []
    }
  },
  mounted () {
    /* 获取父组件的高度 */
    this.$parent.headerHeight(this.$refs.headermodule.clientHeight)
    if (this.$cookie.get('wlymobilephone') !== null && this.$cookie.get('wlymobilephone') !== '') this.isLogin = true
    if (this.$cookie.get('wlyuserimg') !== null && this.$cookie.get('wlyuserimg') !== '') {
      this.user.userimage = this.$cookie.get('wlyuserimg')
    } else {
      this.user.userimage = require('@/assets/common/icon/icon-default-avatar.png')
    }
    if (this.$cookie.get('wlyusername') !== undefined || this.$cookie.get('wlyusername') !== '') {
      this.user.username = this.$cookie.get('wlyusername')
    } else {
      this.user.username = this.$cookie.get('wlymobilephone')
    }
  },
  methods: {
    /* 跳回首页 */
    backindex () {
      // this.$router.push({name: 'index'})
    },
    handleSelect (key, keyPath) {
      // console.log(key, keyPath)
    },
    /* 退出登录 */
    quitlogin () {
      this.isLogin = false
      this.$cookie.delete('token')
      this.$cookie.delete('wlymobilephone')
      this.$cookie.delete('wlyuserimg')
      this.$cookie.delete('wlyuserid')
      this.$cookie.delete('wlyusername')
    },
    gotolink (pathurl) {
      if (this.$route.fullPath.indexOf('redirect') === -1) {
        if (this.$route.query.subhomepage !== undefined) {
          this.$router.push({path: '/' + pathurl, query: {redirect: this.$route.fullPath, subhomepage: this.$route.query.subhomepage}})
        } else {
          this.$router.push({path: '/' + pathurl, query: {redirect: this.$route.fullPath}})
        }
      } else {
        if (this.$route.query.subhomepage !== undefined) {
          this.$router.push({path: '/' + pathurl, query: {redirect: this.$route.query.redirect, subhomepage: this.$route.query.subhomepage}})
        } else {
          this.$router.push({path: '/' + pathurl, query: {redirect: this.$route.query.redirect}})
        }
      }
    },
    gosearch () {
      if (this.$route.query.subhomepage !== undefined) {
        this.$router.push({path: '/search', query: {subhomepage: this.$route.query.subhomepage}})
      } else {
        this.$router.push({path: '/search'})
      }
    },
    gopersonalcenter () {
      if (this.$route.query.subhomepage !== undefined) {
        this.$router.push({path: '/personalcenter', query: {subhomepage: this.$route.query.subhomepage}})
      } else {
        this.$router.push({path: '/personalcenter'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.headermodule-2{
  height: 56px;
  /*background: #3a507a;*/
  background: -webkit-linear-gradient(left, #54a9c8 , #278fb4); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, #54a9c8 , #278fb4); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, #54a9c8 , #278fb4); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #54a9c8 , #278fb4);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#54a9c8, endColorstr=#278fb4);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 888;
  box-shadow: 0 4px 20px rgba(0,0,0,.2);
  .logo{
    img{
      height: 36px;
      margin: 10px 30px 0 10px;
    }
  }
  .btn{
    display: block;
    height: 23px;
    padding: 0 15px;
    line-height: 24px;
    color: #333;
    font-size: 12px;
    background: #fff;
    border-radius: 12px;
    margin: 17px 0 0 ;
    a{
      &:hover{
      }
    }
  }
  .userbox{
    margin: 0 0 0 6px;
    cursor: pointer;
    position: relative;
    height: 56px;
    li{
      height: 100%;
      padding: 17px 0 0;
      .top{
        img{
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
        span{
          line-height: 24px;
          margin: 0 0 0 5px;
          color: #fff;
        }
      }
      .el-popover{
        right: 0;
        top: 54px;
        padding: 0;
      }
      .ul1{
        width: 100%;
        padding: 6px 0;
        li{
          line-height: 36px;
          padding: 0 10px;
          height: auto;
          a{
            display: block;
            i{
              margin: 0 8px 0 0;
            }
          }
          &:hover{
            background: #eee;
            transition: all 0.3s;
          }
        }
      }
    }
  }
  .search_btn{
    text-align: center;
    width: 60px;
    line-height: 24px;
    color: #fff;
    margin: 0 10px 0;
    .ul1{
      width: 80px;
      margin-top: 15px;
      margin-left: -10px;
      border-top: 2px solid #b90b13;
      display: none;
      font-size: 12px;
      text-align: center;
      background: #b90b13;
      box-shadow: 0 0 4px rgba(0,0,0,.3);
      a{
        display: block;
      }
    }
    &:hover{
      .ul1{
        display: block;
        a{
          &:hover{
            background: #a7060d;
            color: #fff;
          }
        }
      }
    }
  }
  /deep/ .el-menu {
    border-bottom: none;
    &.el-menu-demo{
      div{
        li{
          float: left;
          background: transparent!important;
          border-bottom-color: transparent!important;
          &.is-opened,
          &:hover{
            .el-submenu__title{
              background: #1d7ea1!important;
            }
          }
          &.is-active{
            .el-submenu__title{
              color: #fff!important;
            }
          }
        }
      }
    }
  }
  /deep/ .el-popover{
    padding: 5px 0;
    top: 56px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/HeaderModule2.vue